/**
 * TTS utility for 504/IEP accommodation compliance.
 * Uses the Web Speech API — no external libraries.
 */
const tts = {
  speak(text) {
    if (!this.isSupported()) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.9;
    const voices = window.speechSynthesis.getVoices();
    const englishVoice = voices.find((v) => v.lang.startsWith('en'));
    if (englishVoice) {
      utterance.voice = englishVoice;
    }
    window.speechSynthesis.speak(utterance);
  },

  pause() {
    if (this.isSupported()) {
      window.speechSynthesis.pause();
    }
  },

  resume() {
    if (this.isSupported()) {
      window.speechSynthesis.resume();
    }
  },

  stop() {
    if (this.isSupported()) {
      window.speechSynthesis.cancel();
    }
  },

  isSupported() {
    return 'speechSynthesis' in window;
  },

  isSpeaking() {
    return this.isSupported() && window.speechSynthesis.speaking;
  },

  isPaused() {
    return this.isSupported() && window.speechSynthesis.paused;
  },
};

export default tts;
